import React from 'react';
import { m as motion } from 'framer-motion';
import { CheckItem } from './ui/CheckItem';
import type { BonoContent } from '../types/content';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
interface BonoItemProps {
  bono: BonoContent;
  index: number;
}
export function BonoItem({
  bono,
  index
}: BonoItemProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.4,
    ease: easeOut,
    delay: index % 4 * 0.05
  }} className="flex flex-col rounded-2xl border border-mp-border bg-mp-card p-6" data-id="element-29" data-mp="2d5yxcpeijxth">
      <span className="w-fit rounded-full border border-mp-lime/40 bg-mp-lime/5 px-3.5 py-1.5 font-heading text-xs uppercase tracking-wide text-mp-lime" data-id="element-30" data-mp="1pcfp695a27fb">
        {bono.tag}
      </span>

      <h3 className="mt-3 font-heading text-xl uppercase leading-snug text-mp-white" data-id="element-31" data-mp="3jm1551sdp6iu">{bono.title}</h3>

      <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-32" data-mp="3ol4a6m8czcqt">{bono.oneLiner}</p>

      {bono.bullets && <ul className="mt-4 space-y-2" data-id="element-33" data-mp="7u5i715blg01">
          {bono.bullets.map(bullet => <CheckItem key={bullet} data-id="element-34" data-mp="2vax1sjvrfcr">{bullet}</CheckItem>)}
        </ul>}

      {bono.value && <p className="mt-4 text-xs uppercase tracking-wide text-mp-gray/70" data-id="element-35" data-mp="gqwm1zq45z56">Valor: {bono.value}</p>}
      {bono.note && <p className="mt-2 text-xs leading-relaxed text-mp-gray/70" data-id="element-36" data-mp="3l30errblgx29">{bono.note}</p>}
    </motion.div>;
}